import EventBus from '@/app/bus/event-bus.js';

export const stickyMenuMixins = {
	data() {
		return {
		}
	},
	mounted() {
		this.initScrollEvent();
	},
	methods: {
		initScrollEvent() {
			if (this.$route.name === 'Tracking') {
				this.unbindScrollStickyMenu();
			} else {
				this.bindScrollStickyMenu();
			}
		},
		bindScrollStickyMenu() {
			if (this.$route.name === 'Cart' || this.$route.name === 'Checkout') {
				EventBus.$emit('addMenuMargin', false);
				EventBus.$emit('showStickyMenu', false);
				return;
			}

			EventBus.$emit('makeAppFixed', false);

			const edgeOffset = 200; // top and bottom offset 
			const windowHeight = $(window).height();
			let documentHeight = 0;

			let scroll = 0;
			let lastScrollTop = 0;

			$(window).on('scroll', e => {
				scroll = $(window).scrollTop();
				documentHeight = $(document).height();
				
				if (scroll + windowHeight < documentHeight - edgeOffset) {
					// toggle sticky menu upon scroll
					if ((scroll > edgeOffset) && (scroll > lastScrollTop)) {
						EventBus.$emit('addMenuMargin', false);
						EventBus.$emit('showStickyMenu', false);
					} else {
						EventBus.$emit('addMenuMargin', true);
						EventBus.$emit('showStickyMenu', true);
					}
					lastScrollTop = scroll;
				}
			});
		},
		unbindScrollStickyMenu() {
			EventBus.$emit('makeAppFixed', true);
			EventBus.$emit('addMenuMargin', false);
			$(window).unbind('scroll');
		}
	}
  }